import React, { useState } from 'react';
import styles from './SummaryTable.module.css';

const SummaryComponent = ({ 
  summaryData = [
    { item: 'Revenue', previousPeriod: 36.00, currentPeriod: 16.00 },
    { item: 'Costs of Goods Sold', previousPeriod: 13.00, currentPeriod: 10.00 },
    { item: 'Gross Profit', previousPeriod: 0.00, currentPeriod: 0.00 },
    { item: 'Operating Expenses', previousPeriod: -39.99, currentPeriod: 49.00 },
    { item: 'Net Profit', previousPeriod: -49.99, currentPeriod: 36.00 }
  ]
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedRow, setSelectedRow] = useState('Operating Expenses');

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const formatValue = (value) => {
    const absValue = Math.abs(value);
    if (value < 0) {
      return `($${absValue.toFixed(2)})`;
    }
    return `$${value.toFixed(2)}`;
  };

  const getValueClass = (previousValue, currentValue, isPrevious) => {
    // If comparing the same period to itself, don't apply color
    if (previousValue === currentValue) {
      return '';
    }
    
    // For previous period column
    if (isPrevious) {
      return previousValue < currentValue ? styles.negativeValue : styles.positiveValue;
    }
    // For current period column
    else {
      return currentValue < previousValue ? styles.negativeValue : styles.positiveValue;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.summaryHeader}>
        <button onClick={toggleExpand} className={styles.summaryButton}>
          <span className={styles.summaryTitle}>
            {isExpanded ? 'Hide Summary Details' : 'See Summary Details'}
          </span>
          <svg 
            className={`${styles.chevron} ${isExpanded ? styles.rotated : ''}`} 
            fill="currentColor" 
            viewBox="0 0 20 20"
          >
            <path 
              fillRule="evenodd" 
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {isExpanded && (
        <div className={styles.tableContainer}>
          <div className={styles.tableRow}>
            <div className={styles.tableCell}></div>
            <div className={styles.tableHeaderCell}>Previous Period</div>
            <div className={styles.tableHeaderCell}>Current Period</div>
          </div>

          {summaryData.map((row, index) => (
            <div 
              key={index}
              className={`${styles.tableRow}`}
            >
              <div className={styles.tableLabelCell}>
                {row.item}
              </div>
              <div className={`${styles.tableCell} ${getValueClass(row.previousPeriod, row.currentPeriod, true)}`}>
                {formatValue(row.previousPeriod)}
              </div>
              <div className={`${styles.tableCell} ${getValueClass(row.previousPeriod, row.currentPeriod, false)}`}>
                {formatValue(row.currentPeriod)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SummaryComponent;